import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class ViewSubSellersService {

    constructor(private _http: HttpClient) { }

    getsubsellers(data) {
        return this._http.post(environment.api_url + 'admin/candf/subsellerlistbysuperseller', data);
    }

}
